import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Utils from './Utils';
import Grid from '@material-ui/core/Grid';

export default class DialogLogin extends Component {

  constructor(props){
    super(props);
    
  this.state={
    myName: '', //Jméno přihlášeného
    myCount: 1, // Počet osob
    myReservationId: 0, // Id mé rezervace
    isVisibleForm: true,
    myDialogAnswerOpen: false,
    myDialogNameOpen: false,    
    }
  
  // Tenhle binding je nezbytný protože JS má problém s this v callbacku    
  this.handleChangeName = this.handleChangeName.bind(this);
  this.handleChangeCount = this.handleChangeCount.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDialogAnswerClose = () => {
    this.setState({myDialogAnswerOpen: false}); // zavře dialog Answer
    this.props.onClickClose(); // Zavře původní dialog
  };
  handleDialogNameClose = () => {
    this.setState({myDialogNameOpen: false}); // zavře dialog Answer    
  };

handleChangeName(event) {
    this.setState({myName: event.target.value });   
}
handleChangeCount(event) {

  this.setState({myCount: event.target.value });   
}

handleSubmit() {

// Ověření zadání jména
if ( this.state.myName.trim().length === 0 ){
  this.setState({myDialogNameOpen: true }); 
  return;
}

  var formData = new FormData();
        formData.append('addReservation', true);
        formData.append('EventId', this.props.myId);
        formData.append('Name', this.state.myName);
        formData.append('Count', this.state.myCount);
        formData.append('Max', this.props.myMax);
        
        let fetchData = { 
          method: 'POST', body: formData,      
          headers: {
             headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          },  
        }
  
      // A posílám
      fetch(Utils.getURL(), fetchData)   
      .then(response => response.json())
      .then(data => {          
          if ( data["success"]) {
            // console.log('Číslo:',  data["reservation_id"]);
            this.setState({myReservationId: data["reservation_id"] }); // Po přihlášení na hlavní stránku              
            }
          else{
                  // console.log('Neúspěch:', data["message"]);
                    this.setState({myReservationId : 0 })                              
                }
          this.setState({myDialogAnswerOpen: true }); 
      })
      .catch((error) => {
        console.error('Chyba:', error);
      });    
}

/**
 * dá formátovanou odpověď po přihlášení
 */
getAnswer(){
  
  if ( this.state.myReservationId > 0 ){
    return <p><h3>Přihlásili jste se pod číslem: <b> {this.state.myReservationId}
      </b></h3>Toto číslo si můžete pro jistotu poznačit.<br></br>
      Uvidíte ho v "OBSAZENOSTI" místo <br></br>svého jména (ochrana osobních údajů).</p>
  } 
  else {
    return <p><h3>Pozor, nepodařilo se přihlásit!</h3>
    Překročili jste počet volných míst.</p>
  }
}

render() {
    return(
      <div>
        {/* Odpověď */}
        <Dialog disableBackdropClick
          open={this.state.myDialogAnswerOpen}  
          onClose={this.handleDialogAnswerClose}
        >
        <DialogTitle  id="answer-dialog-title">{this.props.myName}</DialogTitle>
        <DialogContent>
        <DialogContentText id="answer-dialog-description">
          {this.getAnswer()}
          
            </DialogContentText>
            </DialogContent>
        <DialogActions>
        <p className="center">
          <Button color="primary" variant="contained" 
              onClick={this.handleDialogAnswerClose} >
            OK
          </Button>          
        </p>
          </DialogActions>         
        </Dialog>
        
{/* Nezadané jméno */}
<Dialog disableBackdropClick
          open={this.state.myDialogNameOpen}  
          onClose={this.handleDialogNameClose}
        >
        <DialogContent>
        <DialogContentText id="name-dialog-description">          
          Prosím zadejte jméno.
            </DialogContentText>
            </DialogContent>
        <DialogActions>
        <p className="center">
          <Button color="primary" variant="contained" 
              onClick={this.handleDialogNameClose} >
            OK
          </Button></p>
          </DialogActions>         
        </Dialog>


{/* Zadávací dialog */}

    <Dialog disableBackdropClick
        open={this.props.myopen} aria-labelledby="alert-dialog-title"  aria-describedby="alert-dialog-description"
        onClose={this.props.onClickClose}
        >

      <DialogTitle  id="form-dialog-title">{this.props.myName}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Zadejte jméno a zvolte počet osob
          </DialogContentText>
          <Grid container spacing={1}>
          <Grid item >
          <FormControl variant="outlined" >
             <TextField  variant="outlined" type="string" id="name" label="Jméno"
              name="name"  autoFocus ="true"
              onChange = {this.handleChangeName}
              />
          </FormControl>
          </Grid>
          <Grid item >
          <FormControl variant="outlined" >
            <InputLabel id="label-1">Počet</InputLabel>
            <Select 
                value={ this.state.myCount } labelId="label-1" id="select-1"   label="Počet osob"       
                onChange={this.handleChangeCount}
              >
                <MenuItem value={1}>1 osoba&nbsp;</MenuItem>
                <MenuItem value={2}>2 osoby&nbsp;</MenuItem>
                <MenuItem value={3}>3 osoby&nbsp;</MenuItem>
                <MenuItem value={4}>4 osoby&nbsp;</MenuItem>
                <MenuItem value={5}>5 osob&nbsp;&nbsp;&nbsp;</MenuItem>
                <MenuItem value={6}>6 osob&nbsp;&nbsp;&nbsp;</MenuItem>
            </Select>
          </FormControl>
          </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button color="primary" 
            onClick={this.props.onClickClose}
            >
            Zrušit
          </Button>
          <p className="space5"></p>
          
          <Button  color="primary" variant="contained" autoFocus
            onClick={this.handleSubmit}
            >
            Přihlásit
          </Button>
          <p className="space8"></p>
          </DialogActions>
        
      </Dialog>
      </div>
    );
}
}